import { currentEnv } from "~/configs";

export const getBaseUrl = (chooseHospital = {}) => {
  return Object.keys(chooseHospital).length &&
    Object.keys(chooseHospital.selectedHospital).length > 0
    ? chooseHospital.selectedHospital.base_url
    : currentEnv.RESTFULL_API_URL;
};
